// Wallet connect errors come straight from the provider (LaserEyes / Xverse / Unisat /
// OYL) as arbitrary English strings we don't control, so we can't translate every one.
// Instead classify into a small set of semantic kinds the UI can localize; the dominant
// case by far is the user dismissing the wallet prompt.
export function classifyWalletError(err) {
  const m = (err?.message || err?.toString?.() || '').toLowerCase();
  if (/reject|deni|declin|cancel|dismiss/.test(m)) return 'rejected';
  return 'generic';
}
